/* Truina product-landing behavior:
   plan selector, galleries, sticky mobile buy bar, FAQ accordions. */

(function () {
  'use strict';

  /* Run-once guard: several sections include this script, and a classic
     <script src> executes once PER TAG — without this, every listener
     attaches twice and each click toggles open + closed again. */
  if (window.TruinaProductInit) return;
  window.TruinaProductInit = true;

  var DESKTOP = 1024;

  /* ---- plan selector ----------------------------------------------------
     Card click -> selected state, swaps variant id + selling plan on the
     buy form, updates the CTA and sticky-bar prices. */
  function initPlanCards(hero) {
    var cards = hero.querySelectorAll('[data-plan-card]');
    if (!cards.length) return;

    var form = hero.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var planInput = form ? form.querySelector('[data-selling-plan-input]') : null;
    var buyPrice = hero.querySelector('[data-buy-price]');
    var buybarPrice = document.querySelector('[data-buybar-price]');
    var buybarPer = document.querySelector('[data-buybar-per]');

    cards.forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (!input) return;

      input.addEventListener('change', function () {
        cards.forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
        });

        if (idInput) idInput.value = input.value;

        var plan = input.dataset.sellingPlan || '';
        if (planInput) {
          planInput.value = plan;
          planInput.disabled = plan === '';
        }

        var price = input.dataset.price;
        var perDay = input.dataset.perDay;
        if (price) {
          if (buyPrice) buyPrice.textContent = price;
          if (buybarPrice) buybarPrice.textContent = price;
        }
        if (perDay && buybarPer) buybarPer.textContent = perDay + ' a day';
      });
    });
  }

  /* ---- desktop gallery --------------------------------------------------- */
  function initDesktopGallery(root) {
    var gallery = root.querySelector('[data-gallery-desktop]');
    if (!gallery) return;

    var images = gallery.querySelectorAll('.truina-gallery-d__image');
    var thumbs = gallery.querySelectorAll('.truina-gallery-d__thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.mediaIndex;
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.mediaIndex === index);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* ---- mobile gallery ---------------------------------------------------- */
  function initMobileGallery(root) {
    var gallery = root.querySelector('[data-gallery-mobile]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-gallery-track]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var dots = gallery.querySelectorAll('.truina-gallery-m__dot');

    function slideWidth() {
      var slide = track.querySelector('.truina-gallery-m__slide');
      return slide ? slide.offsetWidth + 12 : track.offsetWidth;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / slideWidth());
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        ticking = false;
      });
    });
  }

  /* ---- sticky mobile buy bar ---------------------------------------------
     Slides in once the hero buy block has scrolled out of view. */
  function initBuybar() {
    var buybar = document.querySelector('[data-truina-buybar]');
    var buyBlock = document.querySelector('[data-truina-buy]');
    if (!buybar || !buyBlock || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          buybar.classList.toggle('is-visible', passed);
          buybar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );

    observer.observe(buyBlock);
  }

  /* ---- FAQ accordions -----------------------------------------------------
     Mobile: multi-open. Desktop (>= 1024px): exclusive, one open at a time. */
  function initAccordions() {
    document.querySelectorAll('[data-truina-accordion]').forEach(function (list) {
      var items = list.querySelectorAll('.truina-faq__item');

      items.forEach(function (item) {
        var button = item.querySelector('.truina-faq__question');
        if (!button) return;

        button.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          if (!isOpen && window.innerWidth >= DESKTOP) {
            items.forEach(function (other) {
              if (other !== item) setOpen(other, false);
            });
          }
          setOpen(item, !isOpen);
        });
      });

      function setOpen(item, open) {
        var button = item.querySelector('.truina-faq__question');
        var glyph = item.querySelector('.truina-faq__glyph');
        var answer = item.querySelector('.truina-faq__answer');
        var inner = item.querySelector('.truina-faq__answer-inner');

        if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (glyph) glyph.textContent = open ? '−' : '+';

        if (!answer || !inner) {
          item.classList.toggle('is-open', open);
          return;
        }

        /* Animate an explicit pixel height — measured from the content —
           then settle on auto so later reflows (fonts, resize) never clip.
           The pending settle listener must be cleared on close, or it fires
           on the closing transition and snaps the answer back open. */
        if (answer._truinaSettle) {
          answer.removeEventListener('transitionend', answer._truinaSettle);
          answer._truinaSettle = null;
        }

        if (open) {
          item.classList.add('is-open');
          answer.style.height = inner.scrollHeight + 'px';
          var settle = function (evt) {
            if (evt.target !== answer) return;
            answer.style.height = 'auto';
            answer.removeEventListener('transitionend', settle);
            answer._truinaSettle = null;
          };
          answer._truinaSettle = settle;
          answer.addEventListener('transitionend', settle);
        } else {
          answer.style.height = inner.scrollHeight + 'px';
          void answer.offsetHeight; /* flush so the 0 below transitions */
          item.classList.remove('is-open');
          answer.style.height = '0px';
          window.setTimeout(function () {
            /* clear the inline height so the stylesheet's height: 0 is the
               final closed state even if the transition never completes */
            if (!item.classList.contains('is-open')) answer.style.height = '';
          }, 350);
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-truina-hero]').forEach(function (hero) {
      initPlanCards(hero);
      initDesktopGallery(hero);
      initMobileGallery(hero);
    });
    initBuybar();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
